import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PaymentStatusComponent } from './payment-status.component';

@NgModule({
  declarations: [ PaymentStatusComponent ],
  imports: [
    CommonModule,
    MatTooltipModule
  ],
  exports: [ PaymentStatusComponent ]
})
export class PaymentStatusModule {
}
